import React from 'react'
import Spinner from './components/Spinner'

function Loading() {
  return (
    <div>
      <Spinner/>
    </div>
  )
}

export default Loading
